/**
 * Centralized API configuration
 */

export const API_URL = process.env.REACT_APP_API_URL || 'https://api.qrmenu.rw/api';

/**
 * Get the base URL for static assets (uploads).
 * Removes /api suffix from API_URL since uploads are served at domain root.
 */
export const getBaseUrl = (): string => {
    return API_URL.replace(/\/api$/, '');
};

/**
 * Get proper image URL, handling both absolute and relative paths.
 */
export const getImageUrl = (imageUrl: string | null): string | null => {
    if (!imageUrl) return null;

    // If it's already a full URL (http/https), return as is
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl;
    }

    // Uploads are served at domain root /uploads, not /api/uploads
    return `${getBaseUrl()}${imageUrl}`;
};
